import React, { useState, useEffect, useCallback } from "react";
import { Popup as AntdMobilePopup } from "antd-mobile";
import { useT } from "@/i18n/hooks";
import {
  INSURANCE_POPUP_EVENT,
  CLOSE_INSURANCE_POPUP_EVENT,
} from "./triggerInsurancePopup";
import type { InsurancePopupProps } from "./InsurancePopup.types";
import "./InsurancePopup.scss";

export const InsurancePopup: React.FC<InsurancePopupProps> = ({
  className = "",
}) => {
  const t = useT();
  const [visible, setVisible] = useState(false);

  const handleOpen = useCallback(() => {
    setVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    window.addEventListener(INSURANCE_POPUP_EVENT, handleOpen);
    window.addEventListener(CLOSE_INSURANCE_POPUP_EVENT, handleClose);
    return () => {
      window.removeEventListener(INSURANCE_POPUP_EVENT, handleOpen);
      window.removeEventListener(CLOSE_INSURANCE_POPUP_EVENT, handleClose);
    };
  }, [handleOpen, handleClose]);

  return (
    <AntdMobilePopup
      visible={visible}
      onMaskClick={handleClose}
      position="bottom"
      destroyOnClose
      className={`insurance-popup ${className}`}
      maskClassName="insurance-popup__mask"
      bodyClassName="insurance-popup__body"
      bodyStyle={{
        height: "97vh",
        minHeight: "97vh",
        maxHeight: "97vh",
        width: "100%",
        boxSizing: "border-box",
        borderRadius: "1rem 1rem 0 0",
      }}
    >
      <div className="insurance-popup__inner">
        <div className="insurance-popup__sheet">
          {/* Header with logo */}
          <div className="insurance-popup__header">
            <img
              src="https://cp-images.casinoplus.live/images/cp/images/insurance/logo.png"
              alt="PhilFirst"
              className="insurance-popup__logo"
              draggable={false}
            />
            <button
              type="button"
              className="insurance-popup__close"
              onClick={handleClose}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Banner image */}
          <div className="insurance-popup__banner-wrap">
            <img
              src="https://cp-images.casinoplus.live/images/cp/images/insurance/banner.png"
              alt=""
              className="insurance-popup__banner-img"
              draggable={false}
            />
          </div>

          {/* Congratulations message */}
          <div className="insurance-popup__congrats">
            <img
              src="https://cp-images.casinoplus.live/images/cp/images/icon/green-tick.png"
              alt=""
              className="insurance-popup__congrats-icon"
              draggable={false}
            />
            <span className="insurance-popup__congrats-text">
              {t("insurance.congratsMessage")}
            </span>
          </div>

          {/* Scrollable content */}
          <div className="insurance-popup__scroll">
            <div className="insurance-popup__content-box">
              <p className="insurance-popup__title">
                {t("insurance.balanceTitle")}
              </p>
              <p className="insurance-popup__text">
                {t("insurance.balanceDesc")}
              </p>

              <p className="insurance-popup__subtitle">
                {t("insurance.whatsCovered")}
              </p>
              <ul className="insurance-popup__list">
                <li>{t("insurance.covered1")}</li>
                <li>{t("insurance.covered2")}</li>
              </ul>

              <p className="insurance-popup__subtitle">
                {t("insurance.whatsNotCovered")}
                <br />
                {t("insurance.notCoveredSubtitle")}
              </p>
              <ul className="insurance-popup__list">
                <li>{t("insurance.notCovered1")}</li>
                <li>{t("insurance.notCovered2")}</li>
                <li>{t("insurance.notCovered3")}</li>
              </ul>

              <p className="insurance-popup__subtitle">
                {t("insurance.whyMatters")}
              </p>
              <p className="insurance-popup__text">
                {t("insurance.whyMattersDesc")}
              </p>
            </div>
          </div>

          {/* File a claim button */}
          {/* <div className="insurance-popup__footer">
            <button
              type="button"
              className="insurance-popup__claim-btn"
              onClick={() => {
                window.open(
                  "https://www.philfirst.com/balance-insurance",
                  "_blank"
                );
              }}
            >
              {t("insurance.fileClaim")}
            </button>
          </div> */}
        </div>
      </div>
    </AntdMobilePopup>
  );
};

export default InsurancePopup;
